import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      <g id="B" transform="translate(11.000000, 5.000000)">
      <image id="image0" width="100" height="100" x="-10" y="0"
  href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAABGdBTUEAALGPC/xhBQAAACBjSFJN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" />
      </g>
      <path
        stroke="#64FFDA"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50, 5
                  L 11, 27
                  L 11, 72
                  L 50, 95
                  L 89, 73
                  L 89, 28 z"
      />
    </g>
  </svg>
);

export default IconLoader;
